/**
 * @generated SignedSource<<f97fad22e80dee10f77c7be9dab28f8e>>
 * @relayHash ea6a369f657d2c0a543723ee5971b2bf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fc43472f688852c625702a795f91b40223241951732fa6382fc6a52c77c97288

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fc43472f688852c625702a795f91b40223241951732fa6382fc6a52c77c97288",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
